import React from 'react'
import { HubStartupOpportunityDetailFeature } from 'domain/feature/hub/startup/opportunity/detail'

export const HubStartupOpportunityGetPage = (): JSX.Element => {
  return <HubStartupOpportunityDetailFeature />
}
